import { render, staticRenderFns } from "./FiltrosBusqueda.vue?vue&type=template&id=55a0ee0f&"
import script from "./FiltrosBusqueda.vue?vue&type=script&lang=ts&"
export * from "./FiltrosBusqueda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports